import React from 'react';
import { Provider } from 'react-redux';
import { transitions, positions, Provider as AlertProvider } from 'react-alert';
import AlertTemplate from './components/AlertTemplate';

import GlobalStyle from './styles/global';
import Router from './routes';
import theme from './styles/themes';
import store from './store';
import { ThemeProvider } from 'styled-components';
// optional configuration
const options = {
  // you can also just use 'bottom center'
  position: positions.TOP_RIGHT,
  timeout: 5000,
  offset: '30px',
  // you can also just use 'scale'
  transition: transitions.SCALE
};

function App() {
  return (
    <AlertProvider template={AlertTemplate} {...options}>
      <Provider store={store}>
        <ThemeProvider theme={theme.default}>
          <Router />
          <GlobalStyle />
        </ThemeProvider>
      </Provider>
    </AlertProvider>
  );
}

export default App;
